import { referencesAjax } from '../ajax/ReferencesAjax'
import { ErrorResponse } from '../DTOs/Common/ErrorResponse'
import { ShiftDTO } from '../DTOs/ShiftDTO'
import { setLatestShift } from '../state/reducers/shiftReducer'
import { store } from '../state/store'
import { isOnlineNow } from './connectivity'

// Note: brings the persisted latest-shift marker up to date without touching the user's selection
// (unlike ShiftLoginBootstrapper, which also navigates and only runs once per session). The marker
// decides which shift stays editable offline and which shift may be completed offline, so leaving it
// on the shift that was latest at login stranded the crew: a day later the real latest shift read as
// locked, and completing it was refused.
export async function refreshLatestShift(): Promise<void> {
  if (!isOnlineNow()) return

  try {
    const raw = await referencesAjax.getLatestShift()
    if (raw instanceof ErrorResponse || !ShiftDTO.is(raw) || !raw.dayOrNight) return

    const date = typeof raw.date === 'string' ? raw.date : raw.date?.toISODate() ?? null
    if (!date) return

    store.dispatch(setLatestShift({ date, shift: raw.dayOrNight === 'D' ? 'DAY' : 'NIGHT' }))
  } catch {
    // ignore - offline, cancelled or a server error; the marker keeps its previous value
  }
}
